import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import background from "../images/v.jpg";

export default function Timer({ eventTime }) {
    // Calculates time left
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    const getTimeLeft = () => {
        // Find the time left
        let countDownDate = new Date(eventTime).getTime();
        let now = new Date().getTime();
        let distance = countDownDate - now;

        // Get individual components
        setDays(Math.floor(distance / (1000 * 60 * 60 * 24)));
        setHours(
            Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        );
        setMinutes(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
        setSeconds(Math.floor((distance % (1000 * 60)) / 1000));
    };

    useEffect(() => {
        const interval = setInterval(() => getTimeLeft(eventTime), 1000);

        return () => clearInterval(interval);
    });

    // let displayTime = `${days} days, ${hours}:${minutes
    //     .toString()
    //     .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    // Checks if there is time left
    let countDownDate = new Date(eventTime).getTime();
    let now = new Date().getTime();
    let distance = countDownDate - now;
    if (distance < 0) {
        return (
            <div className="container text-center">
                <section className="mt-3 fs-3">Welcome!</section>
                <img
                    src={background}
                    className="my-3 pt-2 pb-5 w-75 h-50"
                    alt={"all characters background with info"}
                />
            </div>
        );
    }

    return (
        <div className="container text-center">
            <section className="mt-3 fs-3">
                See you in {days} days, {hours} hours, {minutes} minutes,{" "}
                {seconds} seconds !!!
                <p>Click below for tickets !!</p>
            </section>
            <a href="https://events.kagw.com/" target="_blank" rel="noreferrer">
                <img
                    src={background}
                    className="my-3 pt-2 pb-5 w-75 h-50"
                    alt={"all characters background with info"}
                />
            </a>
        </div>
    );
}

Timer.propTypes = {
    eventTime: PropTypes.string.isRequired,
};
